$('.message-header').flickity({
  // options
    cellAlign: 'center',
    contain: false,
    initialIndex: 1,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    draggable: true,
    imagesLoaded: false,
    fade: true,
    autoPlay: 5000
});


   
$('.main-carousel').flickity({
  		// options
  	wrapAround: true,
    pageDots: false,
    initialIndex: 1,
    fade: true,
    watchCSS: true,
    prevNextButtons: false,
    accessibility: true, //true by default
    autoPlay: true // advance cells every 3 seconds
});

$('.list-collections').flickity({
  		// options
  	wrapAround: true,
    pageDots: false,
    initialIndex: 1,
    fade: true,
    watchCSS: true,
    prevNextButtons: false,
    accessibility: true, //true by default
    autoPlay: true // advance cells every 3 seconds
});

$(function() {
  initBrandFilter();
});

function initBrandFilter() {
  // Filter using navigation
  $(".brand-nav-item a").click(function() {
    var nav = $(this).attr("data-nav");


    // Remove & Add active class
    $(".brand-nav-item").removeClass("active");
    $(this)
      .parent()
      .toggleClass("active");

    // Hide all the results
    $(".brand-results-row").addClass("inactive");


    // Loop through the row
    $(".brand-results-row").each(function() {
      var term = $(this).attr("data-term");

      if (nav == term) {
        $(this).removeClass("inactive");
      }
    });

    // Only return false if data-toggle is brand
    if ($(this).attr("data-toggle") == "brand") {
      return false;
    }
  
    });
}

